import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import JoinButton from 'components/features/pfm/JoinButton/JoinButton'
import ExternalNavigationContainer from 'components/features/external/ExternalNavigation/ExternalNavigationContainer'
import * as styles from 'components/features/external/ExternalHeaderButtons/ExternalHeaderButtons.styl'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import withMobile, { WithMobileProps } from 'hocs/withMobile/withMobile'
import { HeaderTheme } from 'interfaces/component'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

type ExternalHeaderButtonsProps =
  & WithMobileProps
  & {
    theme: HeaderTheme
    hasExternalNavigation?: boolean
    hasLoginButton?: boolean
    hasJoinButton?: boolean
    isSticky: boolean
  }

const ExternalHeaderButtons: StatelessComponent<ExternalHeaderButtonsProps> = ({
  hasExternalNavigation,
  hasLoginButton,
  hasJoinButton,
  isMobile,
  theme,
  isSticky,
}) => {
  const className = cn(styles.externalHeaderButtons, {
    [styles.withoutExternalNavigation]: !hasExternalNavigation,
    [styles.light]: theme === 'light',
  })

  let loginLinkChild = null
  if (isMobile) {
    if (hasExternalNavigation) {
      loginLinkChild = (
        <span className={ styles.loginLink }>
          Log in
        </span>
      )
    }
  } else {
    loginLinkChild = (
      <Button
        size='responsive'
        theme={ theme === 'dark' ? 'white' : 'blue' }
        style='hollow'
        shadow='light'
      >
        Log in
      </Button>
    )
  }

  return (
    <div className={ className }>
      { hasExternalNavigation && (
        <ExternalNavigationContainer theme={ theme } />
      ) }
      { hasLoginButton && (
        <div className={ styles.buttonWrapper }>
          <NavigationLink to='login'>
            { loginLinkChild }
          </NavigationLink>
        </div>
      )}
      { hasJoinButton && (
        <AnalyticsClick
          className={ styles.buttonWrapper }
          category='page_controls-homepage'
          action='click-join_cta'
          label={ isSticky ? 'sticky_header' : 'header' }
        >
          <JoinButton
            size={ isMobile ? 'micro' : 'responsive' }
            shadow='light'
          >
            { isMobile ? 'Join Status' : undefined }
          </JoinButton>
        </AnalyticsClick>
      )}
    </div>
  )
}

ExternalHeaderButtons.defaultProps = {
  hasExternalNavigation: false,
  hasLoginButton: false,
  hasJoinButton: false,
  isSticky: false,
}

export default withMobile(ExternalHeaderButtons)
